<template>
    <div>
        <div class="mb-3 text-right">
            <hts-form-button
                v-if="checkPermission(layoutPermissions.quote_request_add)"
                color="main"
                icon-name="hi-plus-circle-icon"
                icon-position="right"
                @click="openAddQuoteRequest">
                {{ $t('labels.add') }}
            </hts-form-button>
        </div>
        <hts-data-table
            ref="dataTables"
            :headers="quoteRequest"
            :server="server"
            :use-archive="useQuoteRequestArchive"
            :use-restore="useQuoteRequestRestore"
            use-selection
            store-name="quoteDataTable"
            store-key="QuoteRequest" />
        <quote-request-add
            ref="quoteRequestAdd"
            @refreshTables="refreshTables" />
        <quote-add
            ref="quoteAdd"
            :go-to-management-page="true"
            @refreshTables="refreshTables" />
        <hts-modal
            :show="showPopupDeleteQuoteRequest"
            :title="$t('labels.quoteRequestDelete')"
            type="confirm"
            :content="$t('labels.confirmDeleteQuoteRequest')"
            @hide="showPopupDeleteQuoteRequest = false"
            @confirm="handleDeleteQuoteRequest" />
        <router-view @refresh-tables="refreshTables" />
        <view-history
            ref="viewHistory"
            module="quoteRequest" />
    </div>
</template>

<script setup lang="ts">
import ViewHistory from '../-components/activity.vue'
import QuoteAdd from './quote-request/-components/add-quote.vue'
import QuoteRequestAdd from './quote-request/-components/add.vue'
import { $urlClient } from '#imports'
import { checkPermission } from '@/utils/permission-check'
import Status from '~/components/status.vue'
import layoutPermissions from '~/data/permissions/layout-permissions'
import actions from '~/pages/trucker-[id]/partner/-components/actions.vue'
const { $formatters } = useNuxtApp()
const quoteRequestAdd = ref()

const server = $urlClient.quote.quoteRequest.get

const quoteRequestIdDelete = ref('')
const showPopupDeleteQuoteRequest = ref(false)

const openDeleteQuoteRequest = (quoteData: { [key: string]: any }) => {
  quoteRequestIdDelete.value = quoteData._id
  showPopupDeleteQuoteRequest.value = true
}

const handleEditQuoteRequest = (quote: any) => {
  useRouter().push({ name: 'c-id-quote-quote-request-idquoterequest-edit', params: { idquoterequest: quote._id } })
}
const handleViewQuoteRequest = (quote: any) => {
  useRouter().push({ name: 'c-id-quote-quote-request-idquoterequest-view', params: { idquoterequest: quote._id } })
}
const viewHistory = ref()
const handleViewHistory = (quoteRequest: any) => {
  viewHistory.value && viewHistory.value.open(quoteRequest._id)
}

const notCancel = (data: any) => {
  const status = data.status

  if (typeof status !== 'number') {
    return false
  }

  if ([3].includes(status)) {
    return false
  }

  return true
}

const quoteAdd = ref()

const openCreateQuote = (item: any) => {
  quoteAdd.value && quoteAdd.value.open(item._id)
}

const quoteRequest = [
  {
    field: 'code',
    headerName: $t('labels.code'),
    filter: 'agTextColumnFilter',
    sortable: true
  },
  {
    field: 'positions',
    headerName: $t('labels.route'),
    sortable: true,
    valueFormatter: (params: any) => {
      if (params.data?.positions && Array.isArray(params.data?.positions)) {
        const pluckData = $lodash.map(params.data?.positions, 'fullNameNode')

        return $lodash.join(pluckData, ' >> ')
      }
    },
    filter: 'agTextColumnFilter'
  },
  // {
  //   field: 'transportation',
  //   sortable: true,
  //   headerName: $t('labels.transportation'),
  //   valueGetter: (params: any) => {
  //     const transportation = params.data.transportation
  //     if (transportation === 'CONTAINER') {
  //       return $t('labels.containerTruck')
  //     }
  //     if (transportation === 'NON_CONTAINER') {
  //       return $t('labels.nonContainerTruck')
  //     }
  //   }
  // },
  {
    field: 'customerName',
    headerName: $t('labels.customer'),
    filter: 'agTextColumnFilter'
  },
  // {
  //   field: 'contact.fullName',
  //   headerName: $t('labels.contact')
  // },
  // {
  //   field: 'contact.email',
  //   headerName: $t('labels.email')
  // },
  // {
  //   field: 'contact.phone',
  //   headerName: $t('labels.phone'),
  //   valueGetter: (params: any) => {
  //     if (params?.data?.contact?.phone) {
  //       return `(${params?.data?.contact.phone.code}) ${params?.data?.contact.phone.phone}`
  //     }
  //   }
  // },
  // {
  //   field: 'businessOpportunityName',
  //   headerName: $t('labels.businessOpportunity')
  // },
  {
    field: 'commodityName',
    headerName: $t('labels.commodity')
  },
  {
    field: 'workflowName',
    headerName: $t('labels.workflow')
  },
  {
    field: 'typeContTypeVehicle',
    headerName: 'Loại cont/loại xe',
    valueGetter: (params: any) => {
      const { transportation, contCategory, vehicleCategoryName } = params?.data || {}
      if (transportation === 'CONTAINER' && contCategory) {
        if (params.data?.contCategory === 20) {
          return $t('labels.20f')
        }
        if (params.data?.contCategory === 40) {
          return $t('labels.40f')
        }
        if (params.data?.contCategory === 45) {
          return $t('labels.45f')
        }
      }

      if (transportation !== 'CONTAINER' && vehicleCategoryName) {
        return vehicleCategoryName
      }
    }
  },
  {
    field: 'mergeContainer',
    headerName: 'Yêu cầu đặc biệt',
    valueGetter: (params: any) => {
      const results = [] as string[]
      if (params?.data?.mergeContainer) {
        results.push($t('labels.mergeContainer'))
      }

      if (params?.data?.headContainer) {
        results.push($t('labels.headContainer'))
      }

      return results.join(', ')
    }
  },
  {
    field: 'status',
    headerName: $t('labels.status'),
    cellRenderer: Status,
    cellRendererParams: {
      module: 'quoteRequest',
      label: '',
      keyStatus: 'status'
    },
    minWidth: 230,
    filter: 'TableFilterStatus',
    filterItems: [
      { name: $t('labels.all'), value: null },
      { name: $t('labels.init'), value: 0, class: { '!bg-yellow-100': true, '!text-yellow-800': true } }, // Init: Màu vàng
      { name: $t('labels.quoteCreated'), value: 1, class: { '!bg-green-100': true, '!text-green-800': true } }, // Quote Created: Màu xanh lá cây
      { name: $t('labels.cancel'), value: 3, class: { '!bg-red-100': true, '!text-red-800': true } } // Cancel: Màu đỏ
    ],
    filterModelDefault: { type: 'equals', filterType: 'number' }
  },
  {
    field: 'createdAt',
    headerName: $t('labels.createdAt'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.createdAt)
    }
  },
  {
    field: 'updatedAt',
    headerName: $t('labels.updatedAt'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.updatedAt)
    }
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: actions,
    cellRendererParams: {
      storeKey: 'quoteDataTable',
      storeName: 'QuoteRequest',
      items: [
        {
          icon: 'hi-pencil-square-icon',
          label: $t('labels.edit'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.quote_request_edit),
          click: handleEditQuoteRequest
        },
        {
          icon: 'hi-eye-icon',
          label: $t('labels.viewDetail'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.quote_request_management),
          click: handleViewQuoteRequest,
          isAll: true
        },
        {
          icon: 'hi-plus-circle-icon',
          label: $t('labels.createQuote'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.quote_add),
          validate: notCancel,
          click: openCreateQuote
        },
        {
          icon: 'hi-clock-icon',
          label: $t('labels.viewHistory'),
          class: 'text-orange-600 hover:text-orange-500',
          permissions: checkPermission(layoutPermissions.quote_request_activity),
          click: handleViewHistory
        },
        {
          icon: 'hi-trash-icon',
          label: $t('labels.delete'),
          class: 'text-error-600 hover:text-error-500',
          permissions: checkPermission(layoutPermissions.quote_request_delete),
          click: openDeleteQuoteRequest,
          isArchive: true
        }
      ]
    }
  }
]

const openAddQuoteRequest = () => {
  quoteRequestAdd.value && quoteRequestAdd.value.open()
}

const dataTables = ref()
const refreshTables = () => {
  if (dataTables.value) {
    dataTables.value.refresh()
  }
}

const handleDeleteQuoteRequest = () => {
  const api = $urlClient.quote.quoteRequest.delete
  $api(api, { body: { ids: [quoteRequestIdDelete.value] } })
    .then((data: any) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        process.client && $toast().success($t('labels.deleteQuoteRequestSuccess'))
      }
      refreshTables()
      showPopupDeleteQuoteRequest.value = false
    })
    .catch(() => {
      showPopupDeleteQuoteRequest.value = false
    })
}

const useQuoteRequestArchive = computed(() => {
  return { api: $urlClient.quote.quoteRequest.archive, permissions: checkPermission(layoutPermissions.quote_request_archive) }
})
const useQuoteRequestRestore = computed(() => {
  return { api: $urlClient.quote.quoteRequest.restore, permissions: checkPermission(layoutPermissions.quote_request_restore) }
})
</script>
